import React, { Component } from "react";
import {
  FormControl,
  Grid,
  Paper,
  Divider,
  Button,
  Input,
  Select,
} from "@material-ui/core";
import InputFormat from "../../../partials/inputForm";
import { style } from "./styles";
import { translate } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import LabelForm from "../../../partials/labelForm";
import { connect } from "react-redux";
import ChipInput from "material-ui-chip-input";
import { getNumberOnString } from "../../../partials/validateNumber";
import RelatedProduct from "./relatedProduct";
import MultiLevelCategoryList from "../../productCategory/multiLevelCategoryList";

import DeleteIcon from "@material-ui/icons/Delete";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
class AdditionalInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: this.props.product || {},
      relatedProduct: [],
    };
  }
  async componentDidMount() {
    this.props.getProductCategory();
    if (this.props.product.related_product_ids) {
      let result = await this.props.getProductsByIdArray({
        idArray: this.props.product.related_product_ids,
      });
      this.setState({ relatedProduct: result });
    }
  }
  componentWillReceiveProps = async (nextProps) => {
    if (nextProps.product && nextProps.product.id !== this.state.product.id) {
      this.setState({
        product: nextProps.product,
      });
      if (nextProps.product.related_product_ids) {
        let result = await this.props.getProductsByIdArray({
          idArray: nextProps.product.related_product_ids,
        });
        this.setState({ relatedProduct: result });
      }
    }
  };
  handleChange = (e) => {
    let { product } = this.state;
    if (e.target.name === "position")
      product[e.target.name] = getNumberOnString(e.target.value);
    else product[e.target.name] = e.target.value;
    this.setState(product);
  };
  handleSelectCategory = (name, value) => {};
  handleDeleteChipTag = (chip) => {
    let { product } = this.state;
    let index = product.tags.indexOf(chip);
    product.tags.splice(index, 1);
    this.setState(product);
  };
  handleAddChipTag = (chip) => {
    let { product } = this.state;
    product.tags.push(chip);
    this.setState({ product: product });
  };
  handleOpenRelatedProduct = () => {
    this.RelatedProduct.handleOpenModal();
  };
  addRelatedProduct = (checked) => {
    let { relatedProduct, product } = this.state;
    const new_checked = checked.map(function (row) {
      return {
        _id: row.id,
        name: row.name,
        price: row.regular_price,
        images: row.images,
      };
    });
    relatedProduct = [...relatedProduct, ...new_checked];
    let selectedProductIds = checked.map((e) => e.id);
    let newArr = selectedProductIds.filter(
      (e) => product.related_product_ids.indexOf(e) === -1
    );
    product.related_product_ids = [...product.related_product_ids, ...newArr];
    this.setState({ product: product, relatedProduct: relatedProduct });
    this.RelatedProduct.handleCloseModal();
  };
  getDetailProduct = (id) => {
    let { relatedProduct } = this.state;
    let find = relatedProduct.find((e) => e._id === id);
    return find ? find : {};
  };
  handleDeleteRelatedProduct = async (item) => {
    let { product } = this.state;
    let index = product.related_product_ids.indexOf(item);
    if (index !== -1) {
      product.related_product_ids.splice(index, 1);
      this.setState(product);
    }
  };
  handleSelectCategoryId = (id) => {
    let { product } = this.state;
    product.category_id = id;
    this.setState(product);
  };
  handleSelectCategoryIds = (category_ids) => {
    let { product } = this.state;
    product.category_ids = category_ids;
    this.setState(product);
  };
  render() {
    const { classes, t, notLevelCategories } = this.props;
    let { product } = this.state;
    let category_ids = [];
    let category_id_find = notLevelCategories.find(
      (e) => e.id === product.category_id
    );
    // let category_id = category_id_find ? category_id_find.name : "";
    if (product.category_ids)
      product.category_ids.map((categoryId) => {
        let find = notLevelCategories.find((e) => e.id === categoryId);
        if (find) category_ids.push(find.name);
      });
    return (
      <Paper className={classes.container}>
        <RelatedProduct
          onRef={(id) => (this.RelatedProduct = id)}
          addRelatedProduct={this.addRelatedProduct}
        />
        <Grid container spacing={3}>
          {/* <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                container={true}
                alignItems="flex-end"
              >
                <LabelForm
                  label={t("product_category")}
                  customLabelForm={classes.customLabelForm}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <FormControl className={classes.formControl}>
                  <Select
                    labelId="demo-mutiple-checkbox-label"
                    id="demo-mutiple-checkbox"
                    value={category_id}
                    // onChange={this.handleChange}
                    input={<Input />}
                    name="category_id"
                    renderValue={(selected) => selected}
                  >
                    <MultiLevelCategoryList
                      defaultSelected={product.category_id}
                      handleListItem={this.handleSelectCategoryId}
                      showOnModal={true}
                    />
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
          <Divider className={classes.divider} /> */}

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                container={true}
                alignItems="flex-end"
              >
                <LabelForm
                  label={t("product_category")}
                  customLabelForm={classes.customLabelForm}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <FormControl className={classes.formControl}>
                  <Select
                    labelId="demo-mutiple-checkbox-label"
                    id="demo-mutiple-checkbox"
                    multiple
                    name="category_ids"
                    value={category_ids}
                    // onChange={this.handleChange}
                    input={<Input />}
                    renderValue={(selected) => selected.join(", ")}
                    // MenuProps={MenuProps}
                  >
                    <MultiLevelCategoryList
                      showOnModal={true}
                      defaultSelected={product.category_ids}
                      multiCheck={true}
                      handleSelect={this.handleSelectCategoryIds}
                    />
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Grid>

          <Divider className={classes.divider} />
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                container={true}
                alignItems="flex-end"
              >
                <LabelForm
                  label={t("product_tag")}
                  customLabelForm={classes.customLabelForm}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <ChipInput
                  style={{ width: "100%" }}
                  value={product.tags}
                  onAdd={(chip) => this.handleAddChipTag(chip)}
                  onDelete={(chip, index) =>
                    this.handleDeleteChipTag(chip, index)
                  }
                />
              </Grid>
            </Grid>
          </Grid>

          <Divider className={classes.divider} />
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={6}
                container={true}
                alignItems="flex-end"
              >
                <LabelForm
                  label={t("product_position")}
                  customLabelForm={classes.customLabelForm}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <InputFormat
                  variant="standard"
                  // required
                  // label={t("product_position")}
                  name="position"
                  value={product.position}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>
          </Grid>

          <Divider className={classes.divider} />
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container spacing={0}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                container={true}
                style={{ minHeight: "56px" }}
                alignItems="flex-end"
              >
                <LabelForm label={t("product_related_product")} />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                container={true}
                alignItems="flex-end"
              >
                <List dense={true} className={classes.list}>
                  {product.related_product_ids.map((product_related, index) => {
                    let product = this.getDetailProduct(product_related);
                    return (
                      <ListItem className={classes.listItem}>
                        <ListItemAvatar>
                          <Avatar>
                            {Array.isArray(product.images) &&
                              product.images[0] && (
                                <div
                                  className={classes.avatar}
                                  style={{
                                    backgroundImage: `url(${product.images[0]})`,
                                  }}
                                ></div>
                              )}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={product.name}
                          secondary={product.price}
                        />
                        <ListItemSecondaryAction>
                          <IconButton edge="end" aria-label="delete">
                            <DeleteIcon
                              onClick={() =>
                                this.handleDeleteRelatedProduct(product_related)
                              }
                            />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                      // <Chip
                      //   key={index}
                      //   tabIndex={-1}
                      //   label={this.getDetailProduct(product_related)}
                      //   className={classes.chip}
                      //   onDelete={this.handleDeleteRelatedProduct(
                      //     product_related
                      //   )}
                      // />
                    );
                  })}
                </List>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                container={true}
                style={{ minHeight: "56px" }}
                alignItems="flex-end"
              >
                <Button
                  className={classes.button}
                  variant="contained"
                  color="default"
                  onClick={() => this.handleOpenRelatedProduct()}
                >
                  {t("product_add_product")}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}
const mapState = (state) => ({
  notLevelCategories: state.productCategory.notLevelCategories,
});

const mapDispatch = (dispatch) => ({
  getProductCategory: dispatch.productCategory.getProductCategory,
  getProductsByIdArray: dispatch.product.getProductsByIdArray,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(withStyles(style, { withTheme: 0 })(AdditionalInfo))
);
